import React, { useState, useCallback } from "react";
import { Button, Typography } from "antd";
import { FileSearchOutlined } from "@ant-design/icons";
import DraggableModal from "../../../helper/DraggableModal";

const { Paragraph } = Typography;

export default function useDraggableModal(t) {
    const [modal, setModal] = useState({
        title: "",
        content: "",
    });

    const [visible, setVisible] = useState(false);

    const showModal = useCallback((params) => {
        setModal(params);
        setVisible(true);
    }, []);

    const hideModal = useCallback(() => {
        setVisible(false);
    }, []);

    const getButtonModal = useCallback((params) => (
        <Button type="link" size="small" onClick={() => showModal(params)}>
            <FileSearchOutlined style={{ fontSize: "18px", color: "rgba(0, 0, 0, 0.85)" }} />
        </Button>
    ), [showModal]);

    const IsJsonString = (str) => {
        try {
            return JSON.parse(str);
        } catch (e) {
            return false;
        }
    };

    const IsObject = (object) => {
        if (typeof object === "object") {
            return JSON.stringify(object);
        }
        return false;
    };

    const ModalComponent = (
        <DraggableModal
            name={modal.title}
            visible={visible}
            onOk={hideModal}
            onCancel={hideModal}
            width={800}
            footer={[
                <Button key="submit" type="primary" onClick={hideModal}>
                    {t("tables.actions.ok")}
                </Button>,
            ]}
            context={
                <Typography>
                    <Paragraph className="well">
                        {IsObject(modal.content)
                            ? JSON.stringify(modal.content, null, "\t")
                            : IsJsonString(modal.content)
                                ? JSON.stringify(
                                    JSON.parse(modal.content),
                                    null,
                                    "\t"
                                )
                                : modal.content}
                    </Paragraph>
                </Typography>
            }
        />
    );

    return {
        showModal,
        hideModal,
        getButtonModal,
        ModalComponent,
    };
}